<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="local_shipping"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('transit') }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @blur="getDataFromApi"
          @keydown.enter="getDataFromApi"
        />
      </v-row>
      <v-divider class="my-3" />
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.is_percentage="{ item }">
          <v-chip
            :color="item.is_percentage ? 'blue' : 'green'"
            text-color="white"
          >
            {{ item.is_percentage ? $t('percentage_rate') : $t('static_rate') }}
          </v-chip>
        </template>
        <template v-slot:item.customer="{ item }">
          {{ item.customer && item.customer.name }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              color="red"
              class="mr-5"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            class="ml-auto mt-5"
            @click="editItem({id: null})"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t('new') }}
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('transit') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.title"
                    :label="$t('title')"
                    :rules="rules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="editedItem.cost"
                    :label="$t('price') + ' (' + $t('excl_tax') + ')'"
                    :rules="rules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    disabled
                    :value="((editedItem.cost || 0) * 1.25).toFixed(2)"
                    :label="$t('incl_tax')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="editedItem.type"
                    :items="['servicepoint','pickup','terminal']"
                    :label="$t('type')"
                    :rules="rules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="editedItem.carrier"
                    :items="['dao']"
                    :label="$t('carrier')"
                    :rules="rules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                >
                  <v-text-field
                    v-model="editedItem.erp_product_number"
                    type="number"
                    :label="$t('erp_id')"
                    :rules="rules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                >
                  <v-text-field
                    v-model="editedItem.customer_id"
                    type="number"
                    :label="$t('customer_id')"
                    :rules="rules"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                >
                  <v-text-field
                    v-model="editedItem.priority"
                    type="number"
                    :label="$t('priority')"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="validate"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import { SUPERUSER } from '../../../utils/constants'

  export default {
    mixins: [List],
    data () {
      return {
        endpoint: 'transit',
        name: 'transit',
        crudl: {
          C: SUPERUSER.val,
          R: SUPERUSER.val,
          U: SUPERUSER.val,
          D: SUPERUSER.val,
          L: SUPERUSER.val,
        },
        headers: [
          {
            sortable: false,
            text: this.$t('title'),
            value: 'title',
            width: '100%',

          },
          {
            sortable: false,
            text: this.$t('carrier'),
            value: 'carrier',
          },
          {
            sortable: false,
            text: this.$t('type'),
            value: 'type',
          },
          {
            text: this.$t('erp_id'),
            value: 'erp_product_number',
          },
          {
            text: this.$t('customer'),
            value: 'customer',
          }, {
            text: this.$t('priority'),
            value: 'priority',
          },
          {
            text: this.$t('price'),
            value: 'cost',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        editedItem: {
          title: '',
          cost: '',
          carrier: '',
          type: '',
          erp_product_number: '',
          customer_id: '',
          priority: '',
        },
        defaultItem: {
          title: '',
          cost: '',
          carrier: '',
          type: '',
          erp_product_number: '',
          customer_id: '',
          priority: '',
        },
      }
    },
  }
</script>
